import { processEvmReceipt } from '@src/utils/evm/processReceipt'
import { processSolanaReceipt } from '@src/utils/solana/processReceipt'
import { processTronReceipt } from '@src/utils/tron/processReceipt'

export { processEvmReceipt, processSolanaReceipt, processTronReceipt }

export const processReceipt = processEvmReceipt
